"use strict";
/*
 * @Author: lihaitao
 * @Date: 2020-05-16 10:06:57
 * @Last Modified by: huangzq
 * @Last Modified time: 2020-08-14 16:20:49
 * @Desc 对象存储路径（key）管理方案
 */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * 获取营销资料 key
 * @param account 公司帐号
 * @param scence 场景：H5,article etc
 * @param fileName 文件名
 * @param uuid 唯一 id，用于追踪上传文件，保证文件是从系统上传
 */
function getMaterial(account, scence, fileName, uuid) {
    return "/" + account + "/material/" + scence + "/" + uuid + "/" + fileName;
}
/**
 * 获取普通素材 key
 * @param account 公司帐号
 * @param scence 场景：H5,article etc
 * @param fileName 文件名
 * @param uuid 唯一 id，用于追踪上传文件，保证文件是从系统上传
 */
function getPlain(account, scence, fileName, uuid) {
    return "/" + account + "/material/" + scence + "/" + uuid + "/" + fileName;
}
/**
 * 获取普通素材 key
 * @param account 公司帐号
 * @param scence 场景：H5,article etc
 * @param fileName 文件名
 * @param uuid 唯一 id，用于追踪上传文件，保证文件是从系统上传
 */
function getWXMP(account, scence, fileName, uuid) {
    return "/" + account + "/material/" + scence + "/" + uuid + "/" + fileName;
}
/**
 * 获取对象存储 key, 这里是为了限制对象存储的上传路径，方便管理
 * @param scence 场景值
 * @param fileName 文件名
 * @param config 公共配置
 */
function keyDustessCloud(scence, fileName, config) {
    var keyMap = {
        // 营销资料场景
        H5: getMaterial(config.account, scence, fileName, config.uuid),
        article: getMaterial(config.account, scence, fileName, config.uuid),
        brochure: getMaterial(config.account, scence, fileName, config.uuid),
        case: getMaterial(config.account, scence, fileName, config.uuid),
        form: getMaterial(config.account, scence, fileName, config.uuid),
        cof: getMaterial(config.account, scence, fileName, config.uuid),
        poster: getMaterial(config.account, scence, fileName, config.uuid),
        'video-markting': getMaterial(config.account, scence, fileName, config.uuid),
        'friends-circle': getMaterial(config.account, scence, fileName, config.uuid),
        // 普通素材
        image: getPlain(config.account, scence, fileName, config.uuid),
        video: getPlain(config.account, scence, fileName, config.uuid),
        file: getPlain(config.account, scence, fileName, config.uuid),
        // 官方模板库
        template: "/system/material/" + scence + "/" + config.uuid + "/" + fileName,
        // 小程序
        card: "/" + config.account + "/wxmini/" + scence + "/" + config.uuid + "/" + fileName,
        // 公众号管理
        massmsg: getWXMP(config.account, scence, fileName, config.uuid),
        autoreply: getWXMP(config.account, scence, fileName, config.uuid),
        // 商学院
        mba: "/" + config.account + "/" + scence + "/" + config.uuid + "/" + fileName,
        // crm 商品管理
        goods: "/" + config.account + "/" + scence + "/" + config.uuid + "/" + fileName,
        // crm 客户附件上传
        customerCustomFile: "/" + config.account + "/" + scence + "/" + config.uuid + "/" + fileName
    };
    return keyMap[scence];
}
exports.keyDustessCloud = keyDustessCloud;
//# sourceMappingURL=data:application/json;base64,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